// extracted by mini-css-extract-plugin
module.exports = {"root":"MopedTestPage_root__1uZzl","subtitle":"MopedTestPage_subtitle__2DOuq","text":"MopedTestPage_text__1kaxB","links":"MopedTestPage_links__3re7k"};